<!--  -->
<template>
<div class='container'>
    <div class="item" v-for="(item,i) in studentList" :key="i">
        <div class="title">特种作业人员培训 <span class="right" style="float:right;margin-right:15px">[{{item.pid_sign_id == 0?'补考':''}}]</span> </div>
        <div class="content" style="padding-top:15px">
            <div class="info">
                <span class="left">学员姓名:</span>
                <span class="right">{{item.realname}}</span>
            </div>
        </div>
        <!-- <div class="content">
            <div class="info">
                <span class="left">学员编号:</span>
                <span class="right">{{item.id}}</span>
            </div>
        </div> -->
        <div class="content">
            <div class="info">
                <span class="left">课程班期:</span>
                <span class="right">{{item.plan_name}}</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">考试时间:</span>
                <span class="right">{{item.start_time}}</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">是否合格:</span>
                <span class="right button" style="background-color:#ff4d3f" v-show="(item.is_pass == 0 && item.shicao_is_pass != -1) || (item.shicao_is_pass == 0 && item.is_pass != -1)">不合格</span>
                <span class="right button" v-show="(item.is_pass == 1 && item.shicao_is_pass != -1) || (item.shicao_is_pass == 1 && item.is_pass != -1)">合格</span>
                <span class="right" v-show="item.is_pass == -1 || item.shicao_is_pass == -1">暂未录入成绩</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">理论考试成绩:</span>
                <span class="right">{{item.score}}</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">实操考试成绩:</span>
                <span class="right">{{item.shicao_score}}</span>
            </div>
        </div>
    </div>
    <!-- <div class="item">
        <div class="title">特种作业人员培训</div>
        <div class="content" style="padding-top:15px">
            <div class="info">
                <span class="left">学员姓名:</span>
                <span class="right">何晓</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">学员编号:</span>
                <span class="right">S20190808</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">课程班期:</span>
                <span class="right">0808期</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">考试时间:</span>
                <span class="right">2019/08/08</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">是否合格:</span>
                <span class="right button">及格</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">理论考试成绩:</span>
                <span class="right">95</span>
            </div>
        </div>
        <div class="content">
            <div class="info">
                <span class="left">实操考试成绩:</span>
                <span class="right">30</span>
            </div>
        </div>
    </div> -->
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from 'moment'//解析时间戳
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    studentList:[],//学员成绩
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    getStudentQuery(id){
        this.$http.studentSearchResult({
            sign_id:id
        }).then(res=>{
            this.$store.commit("hideLoading")
            let list = res.data
            for (let index = 0; index < list.length; index++) {
                if(list[index].exam_time){
                    list[index].start_time = moment(list[index].exam_time).format('YYYY/MM/DD')
                }
            }
            if(res.status == 1){
                this.studentList = list
            }
        })
    },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    let id = this.$route.query.id
    this.$store.commit("showLoading")
    this.getStudentQuery(id)
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    padding: 13px 16px;
    box-sizing: border-box;
    .item{
        width: 100%;
        background-color: #fff;
        margin-bottom: 10px;
        border-radius: 10px;
        .title{
            width: 100%;
            height: 49px;
            background-color: #0e88f7;
            color: #fff;
            font-size: 17px;
            line-height: 49px;
            padding-left: 16px;
            box-sizing: border-box;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            font-weight: bold;
        }
        .content{
            width: 100%;
            background-color: #fff;
            padding: 0 16px;
            box-sizing: border-box;
            overflow: hidden;
            padding-bottom: 13px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            .info{
                width: 100%;
                .left{
                    float: left;
                    font-size: 16px;
                    color: #333333;
                }
                .right{
                    float: right;
                    font-size: 16px;
                    color: #333333;
                }
                .button{
                    width: 60px;
                    height: 25px;
                    text-align: center;
                    display: inline-block;
                    background-color: #13BF99;
                    color: #fff;
                    line-height: 25px;
                    border-radius: 12px;
                }
            }
        }
    }
}
</style>